import type { ErrorLike } from '@apollo/client';
import { Alert, Center, Loader } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { errorMessage } from '../apollo/errors';

/**
 * The two states every screen in this console has before it has data. Written
 * once so that a loading table and a failed one look the same everywhere, and
 * so that no page reaches for `error.message` (which is the network's wording)
 * instead of the API's.
 */
export function QueryState({
  loading,
  error,
  children,
}: {
  loading: boolean;
  error?: ErrorLike | undefined;
  children: ReactNode;
}) {
  if (error) return <ErrorAlert error={error} />;

  if (loading) {
    return (
      <Center py="xl">
        <Loader />
      </Center>
    );
  }

  return <>{children}</>;
}

export function ErrorAlert({ error }: { error: ErrorLike }) {
  const { t } = useTranslation();

  return (
    <Alert color="red" icon={<IconAlertTriangle size={18} />} title={t('common.error')}>
      {errorMessage(error)}
    </Alert>
  );
}
